import { FolderArrowDownIcon, LinkIcon } from '@heroicons/react/24/outline';

import Resource from '@/models/_deprecated/Resource';

type ResourceIconProps = {
  resource: Pick<Resource, 'resourceFile' | 'resourceLink'>;
};

export default function ResourceIcon({ resource }: ResourceIconProps) {
  const { resourceFile, resourceLink } = resource;
  const iconClassName = 'w-5 h-5 text-primary shrink-0';
  if (resourceFile)
    return (
      <FolderArrowDownIcon
        className={iconClassName}
        data-testid="FolderArrowDownIcon"
      />
    );
  if (resourceLink)
    return <LinkIcon className={iconClassName} data-testid="linkIcon" />;

  return null;
}
